import { Injectable } from '@angular/core';
import { Router, Route } from '@angular/router';
import { HttpClient } from '@angular/common/http';


import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';

import { LsHelperService } from './ls-helper.service';

import firebase from 'firebase/app';
import 'firebase/database';

@Injectable({
  providedIn: 'root'
})
export class InboxService extends BaseProvider{
	roles: any=[];
	showManagement: boolean=false;
	item: any = {};
	messageCount: number = 0;
	messages: any;
	isLoading: boolean = false;
  	constructor(
  		public router: Router,
		public globals: GlobalsService,
 		public http: HttpClient,		
 		public ls: LsHelperService
  	) { 
		super();

		this.baseUrl = "messaging";		
	}	

    loadMessagingCount() {
		//this.getCount();

		let userId = this.ls.get("userId");

		if(userId){
			this.firebasedb  = firebase
					.database()
					.ref('messaging/' + userId + '/info');

			this.firebasedb.on("value", (resp)=> {
				this.getCount();
			});          	
		}  
    }	

	get() {
		this.isLoading = true;

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			var loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
			.subscribe(
				(data: any) => {

				this.isLoading = false;

				this.list = data.Data;

				resolve(data.Data);
			},
			err => {reject(err)}
			);
		});
	}

	getCount() {
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/count' ;

			var loginData = this.ls.get('loginData');

			this.http.get(
				this.url
			)
			.subscribe(
				(data: any) => {
					this.messageCount = data.Data ? data.Data : 0;
			},
			err => {reject(err)}
			);
		});
	}

	updateSeen(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/seen/" + params.Id;

		    this.http
		    .put(this.url, params)
		    .subscribe(
		        (data: any) => {
		        	resolve(data);

					this.messageCount--

		        	this.gotoUrl(params)
		        },
		        err => {reject(err)}
		    );
		});			
	}	

	gotoUrl(item){

		var url = item.UriPathTemplate

        url = url.replace("{0}", item.EntityId)

		this.router.navigate([url]);
	}

	clearInbox(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/clear";

		    this.http
		    .put(this.url, {})
		    .subscribe(
		        (data: any) => {

		        	this.list = [];	

		        	resolve(data);
		        },
		        err => {reject(err)}
		    );
		});					
	}	

	deleteMessage(messageId){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + `/${messageId}`;

	        this.http
	        .delete(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
	            	this.list = this.list.filter(function (e) {
					      return e.Id !== messageId
					});
					
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });    		
	}
}
